import Button from "components/base/Button";
import { Input, Select } from "components/base/Form";
import ComponentsView from "components/shared/ComponentsView";
import { useModals } from "ModalProvider";
import PackagingOptionForm from "../gtm/PackagingOptionForm";
import ProductPackagingOptionView from "../gtm/ProductPackagingOptionView";

const CostView = ({ title = "Cost", data, onChange }) => {
  const incNumber =
    data.productType === "NEW_CLASSIC_LINE_PRODUCT" ? 0.7 : 0.62;

  const abToIncPrice = data.targetPrice ? parseFloat(data.targetPrice) / 4 : 0;

  const highestCost = abToIncPrice * incNumber;

  const componentsWithCurrency =
    data.components?.map((i) => ({
      ...i,
      prices: i.prices.map((p) => ({
        ...p,
        currency: i.currency || "CNY",
      })),
    })) || [];

  const modal = useModals();

  function addPackagingCost() {
    if (!data.components || data.components.length === 0) {
      window.alert("Please add components before adding packaging options.");
      return;
    }

    modal.present({
      title: "Add Packaging Option",
      children: (
        <PackagingOptionForm
          components={data.components}
          onSave={onSavePackaging}
        />
      ),
    });
  }

  function onSavePackaging(packagingInfo) {
    modal.hide();
    const pkg = data.packagings.find((p) => p.id === packagingInfo.id);
    let newPackagings = [];
    if (pkg) {
      newPackagings = data.packagings.map((p) =>
        p.id === packagingInfo.id ? packagingInfo : p,
      );
    } else {
      newPackagings = [...data.packagings, packagingInfo];
    }
    onChange({ data: { packagings: newPackagings } });
  }

  function editPackaging(packagingInfo) {
    modal.present({
      title: "Edit Packaging",
      children: (
        <PackagingOptionForm
          components={data.components}
          initialValues={packagingInfo}
          onSave={onSavePackaging}
          onDelete={onDeletePackaging}
        />
      ),
    });
  }

  function onDeletePackaging(id) {
    modal.hide();
    const newPackagings = data.packagings.filter((p) => p.id !== id);
    onChange({ data: { packagings: newPackagings } });
  }

  function onChangePackingOption(index, newValues) {
    const newPackagings = data.packagings.map((p, i) =>
      i === index ? { ...p, ...newValues } : p,
    );
    onChange({ data: { packagings: newPackagings } });
  }

  return (
    <div className="card">
      <h5>{title}</h5>

      <div className="mt-4 space-y-4">
        <div className="space-x-3">
          <label>Type: </label>
          <Select
            value={data.productType}
            onChange={(e) =>
              onChange({ data: { productType: e.target.value } })
            }
          >
            <option value="NEW_PRODUCT">New Product</option>
            <option value="NEW_CLASSIC_LINE_PRODUCT">
              New Classic Line Product
            </option>
          </Select>
        </div>

        <div className="flex space-x-3 items-center">
          <label>Target Retail Price: </label>

          <Input
            className="text-center"
            placeholder="0.00"
            value={data.targetPrice}
            onChange={(e) =>
              onChange({ data: { targetPrice: e.target.value } })
            }
          />
        </div>

        <div className="flex space-x-3 items-center">
          <label>Highest Cost: </label>
          <span>{highestCost.toFixed(3)}</span>
        </div>

        <div className="flex space-x-3 items-center">
          <label>Target Price to Inc: </label>
          <span>{abToIncPrice.toFixed(3)}</span>
        </div>
      </div>

      <hr />

      <div className="mt-4">
        <h5>Price Breakdown</h5>

        <div className="mt-2">
          <ComponentsView
            components={data.components}
            onChange={(newValues) => onChange({ data: newValues })}
            bomQty={data.bomQty}
            orderQty={data.orderQty}
            fixedComponentQty
          />
        </div>

        <div className="text-xs mt-2">
          <a
            href="https://wabobaadmin-my.sharepoint.com/:x:/r/personal/sam_waboba_com/Documents/New%20Product%20Info.xlsx?d=w35f3e8f338df42aa9c67ede4e8d78ec8&csf=1&web=1&e=E1b12c"
            target="_blank"
          >
            Go to the shared "New Product Info" Document
          </a>
        </div>

        <hr />
        {data.packagings.length > 0 && (
          <div className="mt-8 space-y-8">
            {data.packagings.map((i, index) => (
              <ProductPackagingOptionView
                key={index}
                components={componentsWithCurrency}
                index={index}
                packagingInfo={i}
                editPackaging={editPackaging}
                incNumber={incNumber}
                highestCost={highestCost}
                onChange={(newComponents) =>
                  onChangePackingOption(index, newComponents)
                }
              />
            ))}
          </div>
        )}
        <div className="mt-8 space-y-2">
          <Button onClick={addPackagingCost}>+ Add Packaging Option</Button>
        </div>
      </div>
    </div>
  );
};

export default CostView;
